import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    className: 'main-hero-banner',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      const banners = document.querySelectorAll( '.main-hero-banner' );
      if ( banners.length ) {
        banners.forEach( ( banner ) => {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: banner,
              start: 'top 75%',
              scrub: 0.15,
              // markers: true,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) banner.classList.add( 'is-loaded' );
              },
              onEnter: ( {progress, direction, isActive} ) => banner.classList.add( 'is-loaded' ),
            },
          } );
        } );
      }

      const setBannerHeight = () => {
        const banner = document.querySelector( '.main-hero-banner__bottom-bar' );
        const cards = document.querySelector( '.main-hero-banner__cards' );

        if ( !banner || !cards ) return;

        const isMobile = window.innerWidth <= 768;

        if ( isMobile ) {
          const cardsRect = cards.getBoundingClientRect();
          const newHeight = Math.max( cardsRect.height - 170, 0 );
          banner.style.height = `${newHeight}px`;
        } else {
          banner.style.height = '108px';
        }
      };

      if ( document.querySelector( '.main-hero-banner__bottom-bar' ) && document.querySelector( '.main-hero-banner__cards' ) ) {
        window.addEventListener( 'load', () => {
          setBannerHeight();
          window.addEventListener( 'resize', setBannerHeight );

          const cards = document.querySelector( '.main-hero-banner__cards' );
          if ( cards && 'ResizeObserver' in window ) {
            const observer = new ResizeObserver( setBannerHeight );
            observer.observe( cards );
          }
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'main-hero-banner', COMPONENT );
} )( app );
